export enum ETipoPermissao {
    Dados = 1,
    Autorizacoes = 2,
    Widgets = 3,
    Relatorios = 4
}
